import React from 'react';
import Steps from './Steps';
import { getOrderStatusStrategy } from 'utils/order';
import { Block } from 'components/Block';

export function OrderStatusInfo (props) {
  const { data } = props;
  const strategy = getOrderStatusStrategy(data);

  // Guard: no strategy
  if (!strategy?.steps) return null;

  return (
    <Block>
      <Steps steps={strategy.steps} />
    </Block>
  );
}
